import React, { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import AuctionTimeAndLocationRerender from "../children/AuctionTimeAndLocationRerender";
import { useDispatch, useSelector } from "react-redux";
import {
  auctionTypeStyle,
  capitalizeEveryFirstLetter,
  convertTo12HourFormat,
  handleDateSetUp,
} from "../../../../../helpers/helpers";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { singleAuctionDetails } from "../../../../../redux/action/singleAuction";
import TimeSlotLoader from "../../../../loader/TimeSlotLoader";
import TimeSlot from "../children/TimeSlot";

function ServiceAuctionDetailsAndTimeSlot() {
  const { id } = useParams();
  const isDastop = useMediaQuery({ query: "(max-width: 1500px)" });
  const isLaptop = useMediaQuery({ query: "(max-width: 1300px)" });
  const isLaptopSmall = useMediaQuery({ query: "(max-width: 1140px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 730px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 530px)" });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const contentRef = useRef();
  const { singleAuctionData, loading } = useSelector(
    (pre) => pre?.singleAuction
  );

  const endDateTime = new Date(
    singleAuctionData?.inspectionSchedule?.endingTime
  );
  const currentDate = new Date();
  const isDisabled = endDateTime ? currentDate > endDateTime : true;

  useEffect(() => {
    dispatch(singleAuctionDetails(id));
  }, [id, dispatch]);

  return (
    <div
      className="full-width gap-1"
      ref={contentRef}
      style={{
        display: "grid",
        gridTemplateColumns: !isLaptop && "1.3fr 0.7fr",
      }}
    >
      <div className={`cover p-2 white`}>
        <div className={`${isMobile ? "flex column" : "valign-wrapper"}`}>
          <h5
            className="margin-0px "
            style={{ flex: "0.96", order: isMobile && "2" }}
          >
            Auction ID:{" "}
            <span className="cercle-purple-text">
              {loading ? (
                <Skeleton width={150} />
              ) : (
                singleAuctionData?.auctionId
              )}
            </span>
          </h5>
          {/* <div className="">
            <button
              className={`button-style pointer ${isMobile && "mb-1"}
              ${
                singleAuctionData?.inspectionRequest?.contactPerson ||
                isDisabled
                  ? "grey lighten-2"
                  : "white-text cercle-purple"
              }`}
              style={{
                padding: isMobile ? "8px 7px" : "10px 20px",
                order: isMobile && "2",
              }}
              onClick={() => navigate(`/request-Inspection/${id}`)}
              disabled={
                singleAuctionData?.inspectionRequest?.contactPerson ||
                isDisabled
              }
            >
              Request Inspection
            </button>

            <button
              className={`button-style pointer ml-1 ${isMobile && "mb-1"} ${
                !singleAuctionData?.inspectionRequest?.contactPerson
                  ? "grey lighten-2"
                  : "white-text cercle-purple"
              }`}
              style={{
                padding: isMobile ? "8px 7px" : "10px 20px",
                order: isMobile && "1",
              }}
              onClick={() => navigate(`/download/inspection-pdf/${id}`)}
              disabled={!singleAuctionData?.inspectionRequest?.contactPerson}
            >
              Download
            </button>
          </div> */}
        </div>

        <AuctionTimeAndLocationRerender
          label={"Auction Date & Time"}
          detail={
            loading ? (
              <Skeleton width={200} />
            ) : (
              `${handleDateSetUp(
                singleAuctionData?.auctionSchedule?.startDate
              )} & ${convertTo12HourFormat(
                singleAuctionData?.auctionSchedule?.startingTime
              )} - ${convertTo12HourFormat(
                singleAuctionData?.auctionSchedule?.endingTime
              )}`
            )
          }
        />

        <AuctionTimeAndLocationRerender
          label={"EMD End Date & Time"}
          detail={
            loading ? (
              <Skeleton width={200} />
            ) : (
              `${handleDateSetUp(
                singleAuctionData?.EMDSchedule?.lastDate
              )} & ${convertTo12HourFormat(
                singleAuctionData?.EMDSchedule?.lastTime
              )}`
            )
          }
        />

        <AuctionTimeAndLocationRerender
          label={"Auction Type"}
          detail={
            loading ? (
              <Skeleton width={200} />
            ) : (
              auctionTypeStyle(singleAuctionData?.auctionType)
            )
          }
        />

        <AuctionTimeAndLocationRerender
          label={"Location"}
          detail={
            loading ? (
              <Skeleton width={200} />
            ) : (
              singleAuctionData?.location?.address ||
              singleAuctionData?.inspectionSchedule?.inspectionLocation
            )
          }
        />
        <AuctionTimeAndLocationRerender
          label={"Auction Mode and Region"}
          descriptionValue={true}
          detail={
            loading ? (
              <Skeleton width={300} />
            ) : (
              ` ${capitalizeEveryFirstLetter(
                singleAuctionData?.auctionMode
              )} and ${singleAuctionData?.auctionRegion || "..."}`
            )
          }
        />
        <AuctionTimeAndLocationRerender
          label={"Description"}
          descriptionValue={true}
          detail={
            loading ? <Skeleton width={300} /> : singleAuctionData?.description
          }
        />

        {!isMobile &&
          (loading ? (
            <Skeleton
              height={300}
              width={isTablet ? 150 : 260}
              style={{
                position: "absolute",
                top: "220px",
                left: isLaptopSmall ? "45%" : isLaptop ? "30%" : "35%",
              }}
            />
          ) : (
            <img
              className="materialboxed"
              src="/images/orderAction.png"
              alt="orderImg"
              style={{
                position: "absolute",
                top: "220px",
                left: isLaptopSmall ? "45%" : isLaptop ? "40%" : "35%",
                width: isTablet ? "250px" : isDastop ? "320px" : "360px",
              }}
            />
          ))}
      </div>
      {loading ? (
        <TimeSlotLoader />
      ) : (
        <TimeSlot singleAuctionData={singleAuctionData} />
      )}
    </div>
  );
}

export default ServiceAuctionDetailsAndTimeSlot;
